import { FC } from "react";

import { SectionScoreCard } from "../SectionScoreCard";

import { StudentPerformanceDashboard } from "./StudentPerformanceDashboard";

type StudentAssessmentViewProps = {
  userId: string;
};

export const StudentAssessmentView: FC<StudentAssessmentViewProps> = ({ userId }) => {
  return (
    <>
      <SectionScoreCard userId={userId} />
      <StudentPerformanceDashboard userId={userId} />
    </>
  );
};
